import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="py-10 md:py-12 bg-secondary-100 border-t border-secondary-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex flex-col items-center md:items-start gap-1">
            <a
              href="/"
              className="text-lg font-heading font-bold text-foreground-900 no-underline cursor-pointer"
            >
              Kakobuy<span className="text-primary-500">Polska</span>
            </a>
            <p className="text-xs text-foreground-500">{t('footer.copyright')}</p>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors whitespace-nowrap cursor-pointer no-underline"
            >
              Kakobuy Spreadsheet
            </a>
            <a
              href="#categories"
              className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors whitespace-nowrap cursor-pointer no-underline"
            >
              Kategorie
            </a>
            <a
              href="#faq"
              className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors whitespace-nowrap cursor-pointer no-underline"
            >
              FAQ
            </a>
            <a
              href="#safety"
              className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors whitespace-nowrap cursor-pointer no-underline"
            >
              Bezpieczeństwo
            </a>
          </div>
        </div>

        <div className="mt-6 pt-5 border-t border-secondary-200/50">
          <p className="text-xs text-foreground-400 text-center leading-relaxed">
            {t('footer.disclaimer')}
          </p>
        </div>
      </div>
    </footer>
  );
}